module.exports = __webpack_public_path__ + "static/img/1_10.1b915582.jpg";